export const white = '#ffffff';
export const lightGrey = '#ebedee';
export const darkGrey = '#767677';
export const black = '#000000';
export const ashGreen = '#a7c1b9';
export const rawGrey = '#6d8194';
export const legendLink = '#3a3e4f'
